import {
  AxisSwitcher,
  BorderGridContainer,
  Button,
  GridBox,
  H2,
  H3,
  IconList,
  Section,
  SpacerWrapper,
  theme,
  TypeWrapper,
} from '@ahmdigital/ui';
import { map } from 'lodash/fp';
import React from 'react';
import styled from 'styled-components';

import { CoverInclusionsSection } from '../../content/data/types';
import constants from '../../../../ahm-constants';

const MEDIUM_SIZE_THRESHOLD = '46rem';
const INCLUSIONS_PER_ROW = 2;

const StyledButton = styled(Button)`
  width: 100%;
  @media (min-width: ${(props) => props.theme.media.md}) {
    max-width: 23.5rem;
  }
`;

const StyledSection = styled(Section)`
  margin: auto;
  max-width: 62rem;
  padding: 0 1rem;
  @media (min-width: ${(props) => props.theme.media.md}) {
    padding: 0;
  }
`;

const StyledIconList = styled(IconList)`
  & li > div {
    padding-bottom: 0.5rem;
  }
`;

const ComprehensiveCover = ({ title, inclusionSections }: CoverInclusionsSection) => (
  <BorderGridContainer>
    <GridBox padding="0">
      <StyledSection variant={['paddingTopSpacer2', 'paddingBottomSpacer2']}>
        <TypeWrapper variant="center">
          <H2 variant="marginBottomSpacer4">{title}</H2>
        </TypeWrapper>

        <SpacerWrapper variant="marginTopSpacer3">
          <AxisSwitcher space="2rem" limit={INCLUSIONS_PER_ROW} threshold={MEDIUM_SIZE_THRESHOLD}>
            {map(
              ({ title: sectionTitle, inclusions }) => (
                <div key={sectionTitle}>
                  <H3 looksLike="h4" variant="marginBottomSpacer9">
                    {sectionTitle}
                  </H3>
                  {/* @ts-expect-error [🤖 PLEASE FIX 🤖]: No overload matches this call. */}
                  <StyledIconList
                    items={[
                      ...map(
                        (inclusion) => ({
                          fill: theme.colors.green,
                          icon: 'tick-circle',
                          text: inclusion.title,
                        }),
                        inclusions,
                      ),
                      {
                        text: '+ Plus heaps more',
                      },
                    ]}
                    variant="simple"
                  />
                </div>
              ),
              inclusionSections,
            )}
          </AxisSwitcher>

          <TypeWrapper variant={['center', 'marginTopSpacer4']}>
            <StyledButton to={constants.URLS.THIRD_PARTY.TRAVEL_INSURANCE_EXTERNAL}>Get a quote</StyledButton>
          </TypeWrapper>
        </SpacerWrapper>
      </StyledSection>
    </GridBox>
  </BorderGridContainer>
);

export default ComprehensiveCover;
